import { createSlice } from '@reduxjs/toolkit';

const githubIssuesConnectionSlice = createSlice({
  name: 'githubIssuesConnection',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    addGithubIssuesConnection: (state, action) => {
      state.data = { ...state.data, ...action.payload };
      state.loading = true;
    },
    removeGithubIssuesConnection: (state) => {
      state.data = {};
      state.loading = false;
    },
  },
});

export const { addGithubIssuesConnection, removeGithubIssuesConnection } =
  githubIssuesConnectionSlice.actions;
export default githubIssuesConnectionSlice.reducer;